import BaseCombatant from "./BaseCombatant";
import GameScene from "../scenes/GameScene";
import EnergyBallMachineAI from "../managers/enemyAI/EnergyBallMachineAI";
import SoundManager from "../managers/SoundManager";

export enum EnergyBallMachineActions {
    IDLE = 0,
    ATTACKING = 1
};

export enum EnergyBallMachineStates {
    NORMAL = 0,
    HIT = 1,
    DEAD = 2
}

export default class EnergyBallMachine extends BaseCombatant {

    currentAction: EnergyBallMachineActions;
    currentState: EnergyBallMachineStates;
    brain: EnergyBallMachineAI | null;
    energyBalls: Phaser.Physics.Arcade.Group;
    shootCooldown: boolean;
    fireDirection: Phaser.Math.Vector2;

    constructor(scene: GameScene, x: number,y: number){
        super(scene,x,y,name);
        this.shadow.setVisible(false);
    
        this.maxHealth = 60;

        this.name = "energyBallMachine";

        const spritesheet = "energyBallMachineSpriteSheet";

        this.scene.anims.create({
            'key': `${this.name}Normal`,
            'frameRate': 6,
            'frames': this.scene.anims.generateFrameNumbers(spritesheet, { frames: [0] }),
            'repeat': -1
        });

        this.scene.anims.create({
            'key': `${this.name}Attack`,
            'frameRate': 6,
            'frames': this.scene.anims.generateFrameNumbers(spritesheet, { frames: [1,2,1,2,1,2] }),
            'repeat': 0
        });

        this.scene.anims.create({
            'key': `${this.name}Dead`,
            'frameRate': 16,
            'frames': this.scene.anims.generateFrameNumbers(spritesheet, { frames: [3,4,5,6,7,8,9,10,11,12,13,12,13,12,13,12,13,12,13,12,13] })
        });

        this.brain = null;
        this.energyBalls = scene.energyBalls;
        this.fireDirection = new Phaser.Math.Vector2(0,0);
        this.setState(EnergyBallMachineStates.NORMAL);

        this.reset();
    }

    move(direction: Phaser.Math.Vector2){
        return;
    }

    takeHit(direction: Phaser.Math.Vector2,damage: number = 10){
        this.health -= damage;
        if(this.health <= 0){
            this.stop();
            this.health = 0;
            this.setState(EnergyBallMachineStates.DEAD);
            return;
        }
        SoundManager.playSfx('machineHit');
        this.setState(EnergyBallMachineStates.HIT);
    }

    isAttacking(){
        return this.currentAction === EnergyBallMachineActions.ATTACKING;
    }

    canBeHit(){
        return (
        this.currentState === EnergyBallMachineStates.NORMAL
        )
    }

    canShoot(){
        return this.shootCooldown;
    }

    shoot(){

    }

    setState(newState: EnergyBallMachineStates){
        switch(newState){
            case EnergyBallMachineStates.NORMAL:
                this.stop();
                this.setAlpha(1);
                this.currentState = newState;
                this.setAction(EnergyBallMachineActions.IDLE);
                this.setFriction(0);
                this.setDrag(0);
                this.setMaxVelocity(0);
                this.setScale(6);
                this.body.setCircle(8);
                this.setOffset(0,0);
                //this.body.setSize(0,0,true);
                this.setImmovable(false);
                this.body.enable = true;
            break;
            case EnergyBallMachineStates.HIT:
                this.setAlpha(0.5);
                this.setDrag(1);
                this.anims.play(`${this.name}Normal`);
                this.scene.time.delayedCall(500, ()=> { this.setState(EnergyBallMachineStates.NORMAL) });
            break;
            case EnergyBallMachineStates.DEAD:
                SoundManager.playSfx('bossDeath');
                this.anims.play(`${this.name}Dead`).once('animationcomplete',()=> { this.setVisible(false) });
                this.shadow.setVisible(false);
                this.body.enable = false;
            break;
        }
        this.currentState = newState;
        return this;
    }

    setAction(newAction: EnergyBallMachineActions){
        if(this.currentState === EnergyBallMachineStates.HIT || this.currentState === EnergyBallMachineStates.DEAD) return;
        switch(newAction){
            case EnergyBallMachineActions.IDLE:
                this.prevDirection.x = 0;
                this.prevDirection.y = 0;
                this.anims.play(`${this.name}Normal`);
                this.currentAction = newAction;
            break;
            case EnergyBallMachineActions.ATTACKING:
                this.shootCooldown = false;
                const cb = () => {
                    this.scene.time.delayedCall(2500, ()=> this.shootCooldown = true );
                    const angle = this.fireDirection.angle();

                    this.energyBalls.get(this.x,this.y).fire(new Phaser.Math.Vector2(Math.cos(angle-1),Math.sin(angle-1)));
                    this.energyBalls.get(this.x,this.y).fire(this.fireDirection);
                    this.energyBalls.get(this.x,this.y).fire(new Phaser.Math.Vector2(Math.cos(angle+1),Math.sin(angle+1)));
                    this.setAction(EnergyBallMachineActions.IDLE);
                }
                this.anims.play(`${this.name}Attack`).once('animationcomplete', cb);
                this.currentAction = newAction;
            break;
        }
    }

    reset(){
        super.reset();
        this.setState(EnergyBallMachineStates.NORMAL);
        this.shootCooldown = true;
        if(this.brain !== null) this.brain.reset();
    }

    update(time: number, delta: number){
        if(this.brain !== null) this.brain.update(time, delta);
    }

}